import { frontConfig } from '../config';

export function warnOrThrow(errMsg: string) {
  if (frontConfig.IS_DEV) {
    throw new Error(errMsg);
  } else {
    console.warn(errMsg);
  }
}
